import React, { useState } from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import DtmfDialpad from 'flow/components/communication-canvas/DtmfDialpad';

interface Props {
    onClick: (symbol: string) => void;
    className: string;
}

const DialpadButton = ({ onClick, className }: Props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const { i18next } = useAppContext();

    const [dialpadTypedNumber, setDialpadTypedNumber] = useState('');

    return (
        <>
            <IconButton
                className={className}
                onClick={(event) => {
                    setOpen((prevOpen) => !prevOpen);
                    setAnchorEl(event.currentTarget);
                }}
                aria-controls={open ? 'dtmf-container' : undefined}
                aria-haspopup="true"
                data-test-id={'dialpad-button'}
                tooltipLabel={i18next.t('Tooltip.Title.DialPad')}
                tooltipPlacement="top"
            >
                <Icon iconKey="dialpad" />
            </IconButton>

            {open && (
                <DtmfDialpad
                    handleSendDtmf={onClick}
                    number={dialpadTypedNumber}
                    setNumber={setDialpadTypedNumber}
                    handleClose={() => {
                        setOpen(false);
                        setAnchorEl(null);
                    }}
                    anchorEl={anchorEl}
                />
            )}
        </>
    );
};

export default React.memo(DialpadButton);
